import { HeroSearchForm } from "components/HeroSearchForm/HeroSearchForm";
import { HeroSearchFormMobile } from "components/HeroSearchForm/HeroSearchFormMobile";
import { FC } from "react";
import { LinearGradient } from "react-text-gradients";

export interface SectionHero4Props {
  className?: string;
}

const SectionHero4: FC<SectionHero4Props> = ({ className = "" }) => {
  return (
    <div
      className={`nc-SectionHero relative ${className} lg:w-8/12 `}
      data-nc-id="SectionHero"
    >
      <div className="flex flex-col lg:flex-row lg:items-center">
        <div className="flex-shrink-0 flex flex-col items-start pb-4 lg:pb-48 xl:pr-14 lg:mr-10 xl:mr-0">
          <span className="text-4xl text-[#121212B2] font-semibold">Find your next car at</span>
          <h2 className="px-4 sm:px-0 font-black text-6xl xl:text-7xl !leading-[114%] text-black mb-16 md:mb-4">
          Autowurx
          </h2>
          
          <span className="text-base md:text-lg text-white flex"></span>
        </div>
      </div>

      <div className="hidden lg:block z-10 mb-12 lg:mb-0 lg:-mt-40 w-full">
        <HeroSearchForm />
      </div>
    </div>
  );
};

export default SectionHero4;
